<template>
    <el-form-item :label="label" :prop="propName">
        <el-upload
          v-show="!src"
          drag
          :http-request="choiceOver"
          action=""
          :show-file-list="false"
          :accept="accept"
          :class="disabled ? 'disabled' : ''"
        >
          <i class="el-icon-upload"/>
          <div class="el-upload__text">
            <template v-if="!isMobile">
              将{{ label }}拖动至此处，或
            </template>
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            大小不可超过 <span class="primary-color">{{ this.humanizeMaxSize }}</span><span v-if="accept === 'image/*' && ratio">，建议图片宽高比例为 <span class="primary-color">{{ ratio }}</span></span>
            <span v-if="placeholder">，{{ placeholder }}</span>
          </div>
        </el-upload>
        <el-input
          v-show="src"
          v-model="src"
          :readonly="true"
          @input="$emit('input', src)"
          :style="`width: ${width}`"
        >
        </el-input>

        <div v-show="src" class="preview-box">
          <img
            v-if="disabled"
            class="img disabled"
            :src="accept === 'image/*' ? src : 'https://img.jiahewushe.com/icon/pdf-cover.png'"
            :style="`box-sizing: border-box;width:${isMobile ? '67vw' : '250px'};height:${(isMobile ? 67 : 250) * ratioValue}${isMobile ? 'vw' : 'px'};border-radius:${borderRadius}`"
            alt=""
          />
          <img
            v-else
            :class="`img${is_drag ? ' img-drag' : ''}`"
            :src="accept === 'image/*' ? src : 'https://img.jiahewushe.com/icon/pdf-cover.png'"
            :style="`box-sizing: border-box;width:${isMobile ? '67vw' : '250px'};height:${(isMobile ? 67 : 250) * ratioValue}${isMobile ? 'vw' : 'px'};border-radius:${borderRadius}`"
            @click="choice"
            @drop.prevent="drop"
            @dragover.prevent
            @dragenter.prevent="is_drag = true"
            @dragleave="is_drag = false"
            alt=""
          />
          <div
            v-show="!isUploading && (!isEdit || (isEdit && isShowClose))"
            :class="`icon-close-box${isDeleting ? '' : ' pointer danger-color-hover'}`"
            :style="`height:${250 * ratioValue}px`"
            @click="close"
          >
            <v-icon v-if="isDeleting" name="loading" class="flex-center"/>
            <v-icon v-else name="close"/>
          </div>
          <el-progress
            v-show="isUploading"
            type="circle"
            :percentage="progress"
            class="upload-progress"
          />
        </div>
      <div v-show="src && !isUploading && !disabled" class="el-upload__tip">
        将新的{{ label }}拖动至上方，或
        <input
          ref="input"
          @change="upload($refs.input.files[0])"
          type="file"
          :accept="accept"
          style="display: none"
        >
        <span class="primary-color pointer" @click="choice">点击替换</span>
        <div class="el-upload__tip" slot="tip">
          大小不可超过 <span class="primary-color">{{ this.humanizeMaxSize }}</span><span v-if="accept === 'image/*' && ratio">，建议图片宽高比例为 <span class="primary-color">{{ ratio }}</span></span>
          <span v-if="placeholder">，{{ placeholder }}</span>
        </div>
      </div>
      <el-alert
        v-if="alert"
        :title="alert"
        type="warning"
        show-icon
        :closable="false"
      />
    </el-form-item>
</template>

<script>
import { putImage, deleteFiles, imageCdnHost } from '@/api/oss';
import { decimalPlaces, dividedBy } from "@/utils/number";

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    prefix: {
      type: String,
      default: '',
    },
    disabled: Boolean,
    isEdit: {
      type: Boolean,
      default: false,
    },
    isShowClose: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '封面',
    },
    ratio: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '100%',
    },
    propName: {
      type: String,
      default: 'avatar',
    },
    borderRadius: {
      type: String,
      default: '0',
    },
    accept: {
      type: String,
      default: 'image/*',
    },
    maxSize: {
      type: Number,
      default: 10485760,// 10 MB
    },
    placeholder: {
      type: String,
      default: '',
    },
    // 公开页面（入职申请页）无登录态：传入邀请 token 改走 token 授权的上传接口，
    // 并禁用需登录的服务端删除（后端本就暂不删除图片，只作本地清空）
    publicToken: {
      type: String,
      default: '',
    },
    alert: {
      type: String,
      default: '',
    }
  },
  data: () => ({
    isUploading: false,
    isDeleting: false,
    progress: 10,
    is_drag: false,
    garbageImages: [],
    // https://img.jiahewushe.com/student/2020/08/03/1596434178.jpeg
    src: '',
    objectKey: '',
  }),
  watch: {
    value: {
      immediate: true,
      handler(e) {
        if (e === this.src) return;

        this.src = e;
        this.objectKey = e.replace(imageCdnHost, '');
      },
    },
    src(e) {
      this.$emit('input', e);
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    ratioValue() {
      if (!this.ratio) return 0.56;
      const ratioArray = this.ratio.split(':');
      return ratioArray[1] / ratioArray[0];
    },
    humanizeMaxSize() {
      return this.getHumanizedSize(this.maxSize);
    },
  },
  beforeDestroy() {
    deleteFiles(this.garbageImages);
    this.garbageImages = [];
  },
  methods: {
    choice() {
      this.$refs.input.value = '';
      this.$refs.input.click();
    },
    drop(e) {
      this.is_drag = false;
      this.upload(e.dataTransfer.files[0]);
    },
    choiceOver(file) {
      this.upload(file.file);
    },
    handleImageLoaded(e) {
      this.src = e.target.result;// 使用箭头函数 这里的this.result换成e.target.result
    },
    readerImg(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = this.handleImageLoaded;
    },
    close() { // 关闭图片
      if (this.isDeleting || !this.objectKey) return;
      // 公开页面没有登录态，DELETE oss 会被 401 踢去登录页，这里只本地清空
      if (this.publicToken) {
        this.objectKey = '';
        this.src = '';
        return;
      }
      if (!this.isEdit) return this.del();
      this.garbageImages.push(this.objectKey);
      this.objectKey = '';
      this.src = '';
    },
    async del() {
      if (this.isDeleting) return;

      const oldObjectKey = this.objectKey;
      this.isDeleting = true;
      const { isError } = await deleteFiles([oldObjectKey]);
      this.isDeleting = false;
      if (isError) return;

      if (oldObjectKey === this.objectKey) {
        this.src = '';
        this.objectKey = '';
      }
    },
    handleProgress(e) {
      const loaded = e.loaded / e.total;
      this.progress = Math.floor(loaded * 100);
    },
    getHumanizedSize(number) {
      if (number < 1024) return `${number} B`;
      if (number < 1048576) return `${decimalPlaces(dividedBy(number, 1024))} KB`;
      if (number < 1073741824) return `${decimalPlaces(dividedBy(number, 1048576))} MB`;
      return `${decimalPlaces(dividedBy(number, 1073741824))} GB`;
    },
    async upload(imageData) {
      if (this.isUploading) return;
      if (this.accept === 'image/*' && imageData.type.split('/')[0] !== 'image') return this.$message.error('请选择图片类型的文件');
      if (this.accept === '.pdf' && imageData.type !== 'application/pdf') return this.$message.error('请选择 PDF 类型的文件');
      if (imageData.size > this.maxSize) return this.$message.error(`文件大小不可超过 ${this.humanizeMaxSize}`);

      this.isUploading = true;
      this.close();
      this.readerImg(imageData);

      const objectKey = await putImage({
        bucket_prefix: this.prefix,
        imageData,
        onboardToken: this.publicToken,
        onProgress: this.handleProgress,
      });

      this.isUploading = false;
      if (!objectKey) return;

      this.progress = 0;
      this.objectKey = objectKey;
      this.src = `${imageCdnHost}${objectKey}`;
      this.$message.success('已完成上传！');
    },
  },
  beforeMount() {
    const { value } = this;
    if (value === this.src) return;

    this.src = value;
    this.objectKey = value.replace(imageCdnHost, '');
  }
};
</script>

<style src="./index.css" scoped/>
